import { refreshBanners } from '../swiper/banner';
import { initRankSwiper } from '../swiper/rank';

onload(() => {
  refreshBanners();
  initRankSwiper();
  document.getElementsByClassName('toggle-company-info')[0].addEventListener('click', ()=> {
    $('.company-info').toggleClass('hide');
  })
}, {});